import { type ReactNode } from 'react';
import { MENTION_PATTERN } from '@apm/contracts';

/**
 * Render `@[Tên hiển thị](uuid)` thành chip, phần còn lại giữ nguyên văn bản.
 *
 * Dùng `MENTION_PATTERN` từ `@apm/contracts` — cùng biểu thức mà backend dùng
 * để rút danh sách người nhắc. Viết lại regex ở đây là tạo bản thứ hai, và khi
 * hai bản lệch nhau thì màn hình tô đậm một cái tên mà không ai được thông báo.
 */
export function MentionText({
  body,
  currentUserId,
}: {
  body: string;
  currentUserId?: string;
}): ReactNode {
  const parts: ReactNode[] = [];
  let cursor = 0;

  // `matchAll` cần cờ `g`; `MENTION_PATTERN` là regex dùng chung nên tạo bản
  // sao để không mang `lastIndex` của lần gọi trước sang lần này.
  const pattern = new RegExp(MENTION_PATTERN.source, 'g');

  for (const match of body.matchAll(pattern)) {
    const [full, name, userId] = match;
    const start = match.index;

    if (start > cursor) parts.push(body.slice(cursor, start));

    const isMe =
      currentUserId !== undefined && userId?.toLowerCase() === currentUserId.toLowerCase();
    parts.push(
      <span
        key={`${start}-${userId}`}
        className={
          isMe
            ? 'rounded-sm bg-primary/20 px-1 font-medium text-foreground'
            : 'rounded-sm bg-muted px-1 font-medium'
        }
      >
        @{name}
      </span>,
    );

    cursor = start + full.length;
  }

  if (cursor < body.length) parts.push(body.slice(cursor));

  // `whitespace-pre-wrap`: người dùng xuống dòng trong ô nhập thì phải thấy
  // xuống dòng khi hiển thị.
  return <span className="whitespace-pre-wrap">{parts}</span>;
}
